import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-besoinclient',
  templateUrl: './besoinclient.component.html',
  styleUrls: ['./besoinclient.component.scss']
})
export class BesoinclientComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
